




















































































import Vue from 'vue';
import { mapState } from 'vuex';
import LoadingModal from './components/LoadingModal.vue';
import ErrorModal from './components/ErrorModal.vue';
import Validation from './mixins/validation';
import Api from './mixins/api';
import axios from 'axios';
import Moment from 'moment';

export default Vue.extend({
	name: 'App',
	mixins: [Validation, Api],
	components: {
		LoadingModal, 
		ErrorModal
	},
	data: () => ({
		isJwtReady: false, 
		isVehicleReady: false, 
		isDealerReady: false
	}),
	methods: {
		getDealer(): void {
			const dealer = (window as any).StoreWebsiteInfo;
			const queryDealerID = dealer.StockDealerID === 0 ? dealer.DealerID : dealer.StockDealerID;
			const storeUrl = -1 != document.referrer.indexOf("azurewebsites") 
				? 'https://tpr-omni-app-service.azurewebsites.net' 
				: 'https://' + dealer.StoreUrl + '.dealer.toyota.com.au';
			const dealerData = {
				dealerName: dealer.DealerName,
				locationName: dealer.LocationName,
				dealerID: dealer.DealerID,
				stockDealerID: dealer.StockDealerID,
				queryDealerID,
				nviUrl: storeUrl,
				depositMinimum: dealer.DepositAmount || 100
			}
			this.$store.commit('setDealer', dealerData);

			const url = Api.returnDealerInfoURL(dealerData.dealerID);
			if (!url){
				this.$store.commit('setError', {
					message: `Sorry, your dealer could not be loaded. Please select a different dealer. `
				});
				return;
			}
			axios.get(url).then((response) => {
				Validation.clog('getDealer');
				Validation.clog(response);
				const closedDays = response.data.HourInfo
					.filter(function (day: any) { return day.IsClosed })
					.map(function (day: any) { return day.Day });

				this.setOpeningHours(response.data.HourInfo);
				this.setCallbackDays(closedDays);

				const dealerSitesArray = response.data.DealerSites.filter((i: any) => {
					return i.LocationType == 'Branch' || i.LocationType == 'Principal'
				});
				if (dealerSitesArray.length){
					const storeData = {
						lmct: dealerSitesArray[0].DealerLicenceNumber,
						primaryDealerCode: response.data.PrimaryDealerCode,
						region: dealerSitesArray[0].Region,
						state: dealerSitesArray[0].State,
						privacyPolicy: response.data.PrivacyPolicy,
						website: 'http://' + response.data.BaseUrl, 
						dealerMetroRural: dealerSitesArray[0].IsMetro,
						branchCode: dealerSitesArray[0].BranchCode, 
						pricingZone: dealerSitesArray[0].PricingZone
					}
					this.$store.commit('setDealer', storeData);
					this.getDealerStoreInfo();
					this.isDealerReady = true;
				}
				else {
					this.$store.commit('setError', {
						message: `Sorry, your dealer does not have a branch. Please select a different dealer. `
					});
				}
			})
			.catch((response) => {
				Validation.clog(response);
				this.$store.commit('setError', {
					message: `Sorry, your dealer could not be loaded. Please try again or select a different dealer. `
				})
			});
		}, 
		setCallbackDays (closedDays: any): void {
			const dateList = [];
			let i = 0;
			const numDays = 6 + i;
			while (i < numDays) {
				const day = Moment().add(i, 'days');
				const rawDate = Moment(day).format('YYYY-MM-DD');
				const month = Moment(day).format('MMM');
				const date = Moment(day).format('DD');
				const dayName = Moment(day).format('ddd');
				if (!closedDays.includes(Moment(day).format('dddd'))){
					dateList.push({ rawDate, date, month, dayName, active: false });
				}
				i++;
          }
          this.$store.commit('setCallbackDays', dateList.slice(0, 4))
        },
		setOpeningHours (data: any): void {
            const hoursList = data
                .map(function (day: any) {
                    const openingArray = day.OpeningTime.split(':')
                    const closingArray = day.ClosingTime.split(':')
                    if (openingArray[0] > 12) {
                        openingArray[0] = parseFloat(openingArray[0]) - 12
                        openingArray[2] = 'pm'
                    } else {
                        openingArray[0] = parseFloat(openingArray[0])
                        openingArray[2] = 'am'
                    }
                    const opening = openingArray[0] + ':' + openingArray[1] + openingArray[2]
                    if (closingArray[0] > 12) {
                        closingArray[0] = parseFloat(closingArray[0]) - 12
                        closingArray[2] = 'pm'
                    } else {
                        closingArray[0] = parseFloat(closingArray[0])
                        closingArray[2] = 'am'
                    }
                    const closing = closingArray[0] + ':' + closingArray[1] + closingArray[2]
                    return { day: day.Day, hours: (day.IsClosed ? 'Closed' : opening + '-' + closing) }
                })
            const todayIndex = hoursList.findIndex((x: any) => x.day === Moment().format('dddd'));
            const hoursListHalf = hoursList.splice(0, todayIndex);
            const finalHoursList = hoursList.concat(hoursListHalf);
            finalHoursList[0].day = 'Today'
            this.$store.commit('setOpeningHours', finalHoursList)
        },
		getDealerStoreInfo(){
			const url = Api.returnDealerAgentURL(this.dealer.dealerID);
			axios.get(url)
			.then((response) => {
				Validation.clog('getDealerStoreInfo')
				Validation.clog(response)
				this.$store.commit('setDealerClosed', {
					DealerClosed: response.data.DealerClosed,
					OnlineOrderClosed: response.data.OnlineOrderClosed
				});
				const agentData = {
					FirstName: response.data.PrimaryAgent.FirstName,
					LastName: response.data.PrimaryAgent.LastName,
					Email: response.data.PrimaryAgent.Email,
					Phone: response.data.PrimaryAgent.Phone,
					PhotoUrl: response.data.PrimaryAgent.PhotoUrl
				}
				this.$store.commit('setStoreWhyBuy', response.data.StoreWhyBuy)
				this.$store.commit('setAgent', agentData)
				if (typeof response.data.VehicleReturnGuarantee !== 'undefined'){
					this.$store.commit('setVRG', response.data.VehicleReturnGuarantee)
				}
				if (typeof response.data.TradeInEnabled !== 'undefined'){
					this.$store.commit('setTradeValuationEnabled', response.data.TradeInEnabled)
				}
				if (typeof response.data.ReferenceEnabled !== 'undefined'){
					this.$store.commit('setReferenceEnabled', response.data.ReferenceEnabled)
				}
				if (response.data.TprEnabled !== 'undefined' && response.data.IsTprDown !== 'undefined'){
					this.$store.commit('setTpr', {
						tprEnabled: response.data.TprEnabled, 
						isTprDown: response.data.IsTprDown
					});
				}
				this.getVehicle();
			})
			.catch((response) => {
				Validation.clog(response)
				this.$store.commit('setError', {
					message: `Sorry, your dealer could not be loaded. Please try again or select a different dealer. `
				})
			});
		},
		getVehicle(): void {
			const v = [];
			const vehicleData = {
				Image: 'https://tdpasset.azureedge.net/static-image/hero/8B89730G0EA20040v2.png'
			}
			v.push(vehicleData);
			this.$store.commit('setVehicleArray', v);
			this.$store.commit('setVehicle', v[0]);
			this.isVehicleReady = true;
		},
	}, 
	computed: {
		...mapState({
			orderNumber(): string {
                return this.$store.state.app.orderNumber;
            },
			lightTheme(): boolean {
				return this.$store.state.app.theme == 'light';
			},
			disclaimers(): Array<string>{
				return this.$store.state.app.disclaimers;
			},
			openModalId(): string {
				return this.$store.state.openModal.id;
			},
			sessionTimeout():  string {
				return this.$store.state.app.sessionTimeout;
			}, 
			session():  string {
				return this.$store.state.app.session;
			}, 
			isLoading(): boolean {
				return this.$store.state.loading.show;
			},
			dealer(): any {
				return this.$store.state.dealer;
			}, 
			vehicle(): any {
				return this.$store.state.vehicle;
			}
		}), 
		isReady(): boolean{
			return this.isJwtReady && this.isDealerReady && this.isVehicleReady;
		}
	}, 
	watch: {
		isReady(){
			this.$store.commit('setLoading', { show: false, data: {} });
		}
	},
	mounted(): void {
		try {  
			document.createEvent("TouchEvent");  
			this.$store.commit('setIsTouchEnabled', true);
		} catch (e) {  
			this.$store.commit('setIsTouchEnabled', false);
		}  
		this.isJwtReady = true;
		this.getDealer();
	}
});
